<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/transmission.svg" />
          </div>
          <div>
            <div class="card_title_1">NETWORK</div>
            <!-- <div class="card_title_2">Last Updated {{ last_update }}</div> -->
          </div>
        </div>
        <!-- <div class="card-header-right" style="top: 0px">
          <div class="input-group">
            <span class="input-group-text" style="background-color: #e6e6e6"
              ><i class="fa fa-search"></i
            ></span>
            <input
              class="form-control"
              style="background-color: #e6e6e6; font-size: 12px; width: 200px"
              type="text"
              placeholder="Search Province, Kabupaten"
            />
          </div>
        </div> -->
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-3 gm-mobile">
          <CardWhite
            v-if="network.length > 0"
            :param="network[0]"
            :height="150"
            :selected="selectedCard === network[0]"
            @click="selectCard(network[0])"
          ></CardWhite>

          <CardWhite
            v-if="network.length > 1"
            :param="network[1]"
            :height="150"
            :selected="selectedCard === network[1]"
            @click="selectCard(network[1])"
          ></CardWhite>

          <CardWhite
            v-if="network.length > 2"
            :param="network[2]"
            :height="150"
            :selected="selectedCard === network[2]"
            @click="selectCard(network[2])"
          ></CardWhite>

          <CardWhite
            v-if="network.length > 3"
            :param="network[3]"
            :height="150"
            :selected="selectedCard === network[3]"
            @click="selectCard(network[3])"
          ></CardWhite>
        </div>
        <div class="col-9 gm-mobile">
          <h5 style="text-transform: uppercase" class="m-0">
            {{ titleNetwork }}
          </h5>
          <!--<img
            style="width: 100%"
            src="@/assets/images/indonesia-rasio-desa-berlistrik.png"
          />-->
          <div v-if="isMap">
            <l-map
              :zoom="simple.zoom"
              :center="simple.center"
              style="height: 500px; z-index: 0"
              :zoomControl="false"
              :dragging="false"
              :options="simple"
            >
              <l-tile-layer :url="simple.url"></l-tile-layer>
              <l-marker
                v-for="(marker, id) in dataMap"
                :key="id"
                :lat-lng="marker.latLng"
                :icon="getIcon(marker)"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  <div class="unit-card">
                    <div
                      class="status-bar"
                      :style="{ backgroundColor: marker.color }"
                    ></div>
                    <div class="unit-info">
                      <span class="unit-name">{{ marker.provinceName }}</span
                      ><br />
                      <span class="unit-status"
                        >{{ formattedNumber(marker.value) }} %</span
                      >
                    </div>
                  </div>
                  <!-- <div>
                    {{ marker.provinceName }}
                    <br />
                    {{ formattedNumber(marker.value) }} %
                  </div> -->
                </l-tooltip>
              </l-marker>
            </l-map>
          </div>

          <div v-if="isMap" class="row">
            <div style="display: flex" class="mbl-gen align-items-end">
              <div
                style="
                  color: #4d4d4d;
                  margin-right: 32px;
                  display: flex;
                  align-items: flex-start;
                "
              >
                <span
                  style="font-size: 48px; font-weight: 500; line-height: 1"
                  >{{ networkDetailRasio.totalValue }}</span
                ><span
                  style="
                    font-size: 26px;
                    margin-top: 9px;
                    font-weight: 400;
                    margin-left: 2px;
                    color: #666666;
                  "
                  >%</span
                >
              </div>
              <div style="margin-right: 32px">
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14.06px;
                    letter-spacing: 0.02em;
                    color: #7e7e7e;
                  "
                >
                  Sem 1 Target
                </div>
                <div
                  style="
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 16.41px;
                    letter-spacing: 0.02em;
                    color: #000000;
                  "
                >
                  {{ networkDetailRasio.totalFirstSemesterTarget }} %
                </div>
              </div>
              <div style="margin-right: 32px">
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14.06px;
                    letter-spacing: 0.02em;
                    color: #7e7e7e;
                  "
                >
                  Sem 2 Target
                </div>
                <div
                  style="
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 16.41px;
                    letter-spacing: 0.02em;
                    color: #000000;
                  "
                >
                  {{ networkDetailRasio.totalSecondSemesterTarget }} %
                </div>
              </div>
              <div
                v-for="(item, id) in networkDetailRasio.items"
                :key="id"
                style="
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 14.06px;
                  letter-spacing: 0.02em;
                  color: #7e7e7e;
                  margin-right: 10px;
                "
              >
                {{ item.instanceName }}
                <span style="color: #00aa4e">{{ item.value }} %</span>
              </div>
            </div>
          </div>
          <div v-if="isMap" class="mt-2">
            <!-- <div class="progress-bar">
              <div
                class="progress-bar-fill"
                :style="{ width: `${totalValue}% ` }"
              ></div>
            </div> -->

            <div class="progress-container">
              <div class="progress-bars">
                <div
                  v-for="n in 100"
                  :key="n"
                  class="progress-segment"
                  :class="{ red: n > totalValue }"
                ></div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              style="display: flex"
              class="m-t-10 mbl-gen justify-content-between"
            >
              <div style="width: 100%" class="m-r-20">
                <span
                  class="text-detail m-r-10"
                  :class="{ 'area-tab-selected': selectedTab === 'reg_opdis' }"
                  @click="selectTab('reg_opdis')"
                >
                  All
                </span>
                <span
                  class="text-detail m-r-10"
                  :class="{
                    'area-tab-selected': selectedTab === 'reg_opdis_sumkal',
                  }"
                  @click="selectTab('reg_opdis_sumkal')"
                >
                  Sumatera & Kalimantan
                </span>
                <span
                  class="text-detail m-r-10"
                  :class="{
                    'area-tab-selected': selectedTab === 'reg_opdis_jamali',
                  }"
                  @click="selectTab('reg_opdis_jamali')"
                >
                  Jawa, Madura & Bali
                </span>
                <span
                  class="text-detail"
                  :class="{
                    'area-tab-selected': selectedTab === 'reg_opdis_sulmapana',
                  }"
                  @click="selectTab('reg_opdis_sulmapana')"
                >
                  Sulawesi, Papua, Maluku & Nusa Tenggara
                </span>
              </div>
              <!-- <div style="width: 25%">
                <select v-model="uuid" class="custom-dropdown form-select">
                  <option
                    v-for="(option, key) in dataUuid"
                    :key="key"
                    :value="option.value"
                    :disabled="option.disabled"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div> -->
            </div>
            <div class="card-body">
              <div class="justify-content-between" style="display: flex">
                <div>
                  <span
                    :style="
                      period === 'monthly'
                        ? 'text-decoration: underline; color:#00A3E9'
                        : ''
                    "
                    style="cursor: pointer"
                    @click="selectPeriod('monthly')"
                    class="f-light m-r-10"
                    >Monthly</span
                  >|<span
                    style="cursor: pointer"
                    :style="
                      period === 'quarterly'
                        ? 'text-decoration: underline;color:#00A3E9'
                        : ''
                    "
                    @click="selectPeriod('quarterly')"
                    class="f-light m-l-10 m-r-10"
                    >Quarterly</span
                  >|<span
                    style="cursor: pointer"
                    :style="
                      period === 'yearly'
                        ? 'text-decoration: underline;color:#00A3E9'
                        : ''
                    "
                    @click="selectPeriod('yearly')"
                    class="m-l-10 m-r-10 f-light"
                    >Yearly</span
                  >
                </div>
                <div class="d-flex align-items-center justify-content-end">
                  <div class="me-2">
                    <img src="@/assets/images/a/target.svg" />
                  </div>
                  <div style="font-size: 12px; color: #838383">Target</div>
                </div>
              </div>
              <div class="thermal-mobile">
                <apexchart
                  height="400"
                  width="100%"
                  type="line"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalNetworkMap
      :showModal="modalMap.show"
      :dataNetwork="dataNetwork"
      :titleNetwork="titleNetwork"
      :idDetailMap="idDetailMap"
      @closeModal="onCloseModalMap"
    ></ModalNetworkMap>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
} from "@vue-leaflet/vue-leaflet";
import { latLng, icon } from "leaflet";

import ModalNetworkMap from "../modals/ModalNetworkMap.vue";
import { formattedNumber } from "@/utils/helper";
import DistributionService from "@/services/distribution/distribution";
import ReferenceService from "@/services/reference/reference";
import CardWhite from "./CardWhiteNetwork.vue";
import ProgressBar from "./BarComponent.vue";
import "leaflet/dist/leaflet.css";

const getRef = ReferenceService.build();
const apiDistribution = DistributionService.build();

export default {
  props: ["data"],
  components: {
    ProgressBar,
    ModalNetworkMap,
    IconSvg,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    CardWhite,
  },
  data() {
    return {
      blocks: [
        ...Array(98).fill({ color: "green" }),
        ...Array(2).fill({ color: "red" }),
      ],
      totalSegments: 100,
      greenSegments: 50,
      last_update: "",
      uuid: "",
      dataUuid: [],
      period: "monthly",
      chartOptions: {},
      series: [],
      isMap: true,
      dataNetwork: [],
      modalMap: {
        show: false,
        load: false,
      },
      titleNetwork: "",
      unit: "",
      totalValue: "",
      dataMap: [],
      simple: {
        zoomControl: false,
        dragging: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
        zoom: 5,
        center: [-1.8263233, 118.3522204],
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        iconBlue: icon({
          iconUrl: "map-marker-circle-blue.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
      },
      selectedTab: "reg_opdis",
      selectedCard: 0,
      network: [],
      networkDetailRasio: {},
      netorkDetailJaringan: {},
      idDetailMap: "",
    };
  },
  mounted() {
    this.getDataDistributionNetwork("");
    this.getRefUid("all");
    this.getResolution();
  },
  watch: {
    uuid() {
      let params = {
        id: this.selectedCard.metricId,
        instance: this.uuid,
        periodType: this.period,
      };
      // this.getDataDistributionNetworkDetailJaringan(params);
    },
  },
  methods: {
    getIcon(item) {
      return L.divIcon({
        className: "my-custom-pin",
        html: `<div style="background-color: ${item.color}; width: 10px; height: 10px; border-radius: 50%;"></div>`,
        iconSize: [16, 16], // Size of the icon
        iconAnchor: [8, 8], // Anchor the icon to the center
      });
    },
    getResolution() {
      this.simple.dragging = window.screen.width < 760 ? true : false;
    },
    async getRefUid(id) {
      this.uuid = "";
      const param = {
        sort: "name",
        direction: "asc",
        parentId: id,
      };
      const res = await getRef.getRefUidFilter(param);
      const data = res.data.data;
      const defaults = {
        label: "All UID",
        value: "",
        // disabled: true,
      };
      this.dataUuid = data;
      this.dataUuid.push(defaults);
    },
    selectPeriod(period, data) {
      this.period = period;
      let params = {
        id: this.selectedCard.metricId,
        instance: this.selectedTab,
        periodType: this.period,
      };
      if (params.id !== undefined && !data) {
        this.getDataDistributionNetworkDetailJaringan(params);
      }
    },
    selectTab(tab) {
      this.selectedTab = tab;
      let params = {
        id: this.selectedCard.metricId,
        instance: tab,
        periodType: this.period,
      };
      this.getRefUid(tab);
      this.getDataDistributionNetworkDetailJaringan(params);
    },
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    clickMarker(x) {
      this.modalMap.show = true;
      this.dataNetwork = x;
    },
    selectCard(id) {
      this.period = this.period;
      this.selectedTab = "reg_opdis";
      this.idDetailMap = id.metricId;
      this.selectedCard = id;
      this.titleNetwork = id.metricName;
      this.unit = id.unit;
      let params = {
        id: id.metricId,
        instance: this.uuid === "default" ? "reg_opdis" : this.uuid,
        periodType: "monthly",
      };
      const found = id.metricId.includes("JT");
      if (found) {
        this.selectPeriod("monthly", true);
        this.getDataDistributionNetworkDetailJaringan(params);
        this.isMap = false;
      } else {
        this.selectPeriod("monthly", false);
        this.isMap = true;
        this.getDataDistributionNetworkDetailRasio(params);
      }
    },
    async getDataDistributionNetworkMap(data) {
      this.dataMap = [];
      let param = Object.assign({
        metricId: data.id !== undefined ? data.id : data.metricId,
      });
      const res = await apiDistribution.getDataDistributionNetworkMap(param);
      if (res && res.status == 200) {
        const arrayOfObjects = res.data.data;
        arrayOfObjects.forEach((obj) => {
          obj.latLng = [parseFloat(obj.latitude), parseFloat(obj.longitude)]; // Add 'age' key with value 30 to each object
        });
        this.dataMap = arrayOfObjects;
      }
    },
    async getDataDistributionNetwork(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistributionNetwork(param);
      if (res && res.status == 200) {
        this.last_update = res.data.lastUpdate;
        this.network = res.data.data;
        const param = {
          id: res.data.data[0].metricId,
        };
        this.selectCard(res.data.data[0]);
        this.getDataDistributionNetworkMap(param);
        this.getDataDistributionNetworkDetailRasio(param);
      }
    },

    async getDataDistributionNetworkDetailRasio(params) {
      let param = Object.assign({
        metricId: params.id,
      });
      const res = await apiDistribution.getDataDistributionNetworkDetailRasio(
        param
      );
      if (res && res.status == 200) {
        this.totalValue = res.data.data.totalValue;
        // this.isMap = true;
        this.networkDetailRasio = res.data.data;
        this.getDataDistributionNetworkMap(param);
      }
    },

    async getDataDistributionNetworkDetailJaringan(params) {
      let param = Object.assign({
        metricId: params.id,
        instance: params.instance,
        periodType: params.periodType,
      });
      const res =
        await apiDistribution.getDataDistributionNetworkDetailJaringan(param);
      if (res && res.status == 200) {
        const data = res.data.data;
        const target = data.map((obj) => obj.target);
        const value = data.map((obj) => obj.value);
        const label = data.map((obj) => obj.label);
        const datas = [
          {
            color: "#FF9900",
            name: "Target",
            type: "line",
            data: target,
          },
          {
            color: "#00a3e9",
            name: "Actual",
            type: "column",
            data: value,
          },
        ];
        this.chartOptions = {
          chart: {
            height: 350,
            type: "line",
            toolbar: {
              show: false, // Hide toolbar
            },
            zoom: {
              enabled: false, // Disable zooming
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "50%", // Adjust column width
            },
          },
          tooltip: {
            y: {
              show: true,
              formatter: function (val, seriesIndex, dataPointInde) {
                return val.toLocaleString();
              },
            },
          },
          colors: [
            function ({ value, seriesIndex, dataPointIndex, w }) {
              const data = w.config.series;
              const item = data.filter((item) => item.type === "line");
              if (
                (data[1] && dataPointIndex == 10) ||
                (data[1] && dataPointIndex == 11)
              ) {
                return "#868e96";
              } else {
                return "#00a3e9";
              }
            },
          ],
          yaxis: [],
          legend: {
            show: false,
            position: "top",
            labels: {
              // colors: ["#ff5151", "#8099D9", "#333"], // Define label colors
            },
            markers: {
              width: 12,
              height: 12,
              strokeWidth: 0,
              strokeColor: "#ff5151",
              radius: 12,
            },
          },
          stroke: {
            width: [4, 0], // Set different line widths for line and column series
            curve: "smooth", // Smoothen the line series
            dashArray: [4, 0, 0, 0],
          },
          markers: {
            curve: "straight",
            width: 1, // Set the size of the markers
            colors: ["#FF9900"], // Set the color of the markers
            strokeWidth: 4, // Set the width of the markers' border
          },
          responsive: [
            {
              breakpoint: 1795,
              options: {
                chart: {
                  width: "100%",
                  height: 500,
                },
              },
            },
            {
              breakpoint: 1661,
              options: {
                chart: {
                  height: 500,
                },
              },
            },
            {
              breakpoint: 767,
              options: {
                chart: {
                  height: 400,
                },
                plotOptions: {
                  bar: {
                    columnWidth: "35px",
                  },
                },
                yaxis: {
                  labels: {
                    show: false,
                  },
                },
              },
            },
            {
              breakpoint: 481,
              options: {
                chart: {
                  height: 300,
                  width: "100%",
                },
                xaxis: {
                  labels: {
                    rotate: -30,
                  },
                },
              },
            },
            {
              breakpoint: 420,
              options: {
                chart: {
                  height: 300,
                  width: 700,
                },
                xaxis: {
                  labels: {
                    rotate: -30,
                  },
                },
              },
            },
          ],
          xaxis: {
            categories: label,
            labels: {
              show: true,
              style: {
                colors: "#9B9B9B",
              },
            },
          },
        };
        this.series = datas;
        // this.isMap = false;
        this.networkDetailJaringan = res.data.data;
      }
    },
    formattedNumber,
  },
};
</script>
<style scoped>
.area-tab-selected {
  padding: 5px 10px;
  border-radius: 8px;
  background-color: #00a3e9;
  color: #fff;
}
/* .progress-bar {
  width: 100%;
  height: 20px;
  background-color: #ff0000;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.progress-bar-fill {
  height: 100%;
  background-color: #0ced71;
  transition: width 0.3s ease;
}
.progress-bars {
  height: 20px;
  background-color: #eee;
  border-radius: 5px;
} */

.progress-fill {
  height: 100%;
  border-radius: 5px 0 0 5px;
}
.unit-card {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  background-color: #333;
  color: white;
}

.status-bar {
  width: 5px;
  height: 30px;
  margin-right: 10px;
  border-radius: 3px;
  background-color: #00a3e9;
}

.unit-info {
  flex-grow: 1;
}

.unit-name {
  font-weight: bold;
}
::v-deep .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center,
.apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
  justify-content: center;
  right: 100px !important;
}
.progress-container {
  width: 100%;
}

.progress-bars {
  display: flex;
  gap: 2px;
  height: 15px;
  width: 100%;
}

.progress-segment {
  flex: 1;
  background: #4caf50;
  height: 100%;
  transition: background-color 0.3s ease;
}

.progress-segment.red {
  background: #f44336;
}
</style>
